import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';
import App from './App.tsx';
import './index.css';
import { installStaleChunkRecovery } from './lib/staleChunk';

// Após um deploy, chunks com hash antigo somem do servidor e imports dinâmicos
// de abas abertas falham. Recarregar busca o index.html novo. O evento do Vite
// nunca é cancelado: cancelar faria o import() resolver com `undefined` em vez
// de rejeitar (ver installStaleChunkRecovery).
installStaleChunkRecovery();
// import { initializePerformanceSystem } from './lib/performance/init';

// DESATIVADO: Inicializar sistema de performance
// initializePerformanceSystem().catch(error => {
//   console.error('Failed to initialize performance system:', error);
// });

const sentryDsn = import.meta.env.VITE_SENTRY_DSN as string | undefined;
if (sentryDsn && import.meta.env.PROD) {
  Sentry.init({
    dsn: sentryDsn,
    environment: import.meta.env.MODE,
    release: import.meta.env.VITE_APP_VERSION as string | undefined,
    tracesSampleRate: 0.1,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0.5,
    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  });
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);